// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Divider } from 'antd'
import { getLocalStorage } from 'shared/libs/storage/localStorage'

import React from 'react'

import { Alert } from 'shared/ui/Alert'
import LogoMain from 'shared/ui/App/LogoMain'
import { Space } from 'shared/ui/Space'
import Title from 'shared/ui/Title'

interface Props {
  children?: React.ReactNode
  path?: string
}

interface State {
  errorText: string
  crashData: string
  isOpenDetail: boolean
}

class ErrorHoc extends React.Component<Props, State> {
  constructor(props) {
    super(props)

    this.state = {
      errorText: null,
      crashData: null,
      isOpenDetail: false,
    }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    const isDynamicImportError = error.message.includes(
      'Failed to fetch dynamically imported module',
    )

    const wasReloaded = getLocalStorage('dynamicImportReloaded')

    if (isDynamicImportError && !wasReloaded) {
      localStorage.setItem('dynamicImportReloaded', 'true')
      window.location.reload()
      return
    }

    this.setState({
      errorText: error.message,
      crashData: errorInfo.componentStack,
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.path !== this.props.path) {
      this.setState({
        errorText: null,
        crashData: null,
        isOpenDetail: false,
      })
    }
  }

  toggleIsOpenDetail = () => {
    this.setState((prev) => ({
      ...prev,
      isOpenDetail: !this.state.isOpenDetail,
    }))
  }

  onReload = () => {
    window.location.reload()
  }

  render() {
    const { errorText, crashData } = this.state

    const { path } = this.props

    if (errorText) {
      return (
        <div className="p-[25px]">
          <div>
            <LogoMain />
            <Title
              level={3}
              className="!m-[0px]"
            >
              Все в порядке! Баги происходят очень редко
            </Title>
            <Title
              className="!m-[0px]"
              level={5}
            >
              Раз уж это произошло отправьте скрин разработчикам
            </Title>
            <Divider />
          </div>
          <Alert
            showIcon
            message={errorText}
            description={
              <Space direction="vertical">
                Браузери и ОС: {navigator.appVersion}
                <br />
                Разрешение экрана: {window.screen.width} на{' '}
                {window.screen.height}
                <br />
                Путь: {path}
                <br />
                Отладка: {crashData}
              </Space>
            }
            type="error"
          />
        </div>
      )
    }

    localStorage.removeItem('dynamicImportReloaded')
    return this.props.children
  }
}

export default ErrorHoc
